import React from "react";
import { Box, useTheme } from "@mui/material";

import Logo from "../assets/images/logo.png";
import CompanyInformation from "./CompanyInformation";

export default function Footer() {
  const theme = useTheme();

  return (
    <Box color="white">
      <Box
        sx={{
          backgroundColor: theme.palette.primary.light,
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          justifyContent: "space-between",
          gap: 5,
          padding: { xs: 4, lg: 6 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 1,
            flexGrow: 0,
          }}
        >
          <CompanyInformation />
        </Box>
        <Box>
          <img alt="logo" src={Logo} width={75} />
        </Box>
      </Box>
    </Box>
  );
}
